<template>
  <ol class="relative border-s border-gray-700">
    <li 
      class="mb-3 ms-6"
      v-for="(item, index) in modules" :key="index"
    >
      <template v-if="item?.lessons?.length">
        <!-- icon module -->
        <span
          class="absolute flex items-center justify-center w-6 h-6 rounded-full -start-3 ring-8 ring-gray-900 "
          :class="badgeClass(moduleStatus(item?.id))"
        >
          <component
            :is="iconFor(moduleStatus(item?.id))"
            class="w-4 h-4 "
          />
        </span>

        <!-- title modulo -->
        <h3 class="flex items-center mb-1 text-lg font-semibold text-white tracking-wider">
          {{ item?.title }}

          <!-- status modulo -->
          <span 
            class="text-sm font-medium me-2 px-2.5 py-0.5 rounded-sm ms-3"
            :class="badgeClass(moduleStatus(item?.id))"
          >
            {{ label(moduleStatus(item?.id)) }}
          </span>
        </h3>

        <!-- aulas -->
        <div>
          <Classes
            :lessons="item?.lessons"
          />
        </div>
      </template>
    </li>
  </ol>

  <section class="relative">
    <div class="mb-3 ms-6">
      <button
        type="button"
        class="group flex items-center gap-2 focus:outline-none"
        :class="canStartAssessment ? 'cursor-pointer' : 'cursor-not-allowed opacity-60'"
        :aria-disabled="!canStartAssessment"
        @click="goToAssessment"
        title="Avaliação final"
      >
        <!-- ícone -->
        <span
          class="absolute flex items-center justify-center w-6 h-6 rounded-full -start-3 ring-8 ring-gray-900"
          :class="iconStatus(trainingStatus)"
        >
          <PhListChecks class="w-4 h-4" />
        </span>

        <!-- label -->
        <p
          class="flex items-center mb-1 text-lg font-semibold tracking-wider"
          :class="assessmentStatus(trainingStatus)"
        >
          AVALIAÇÃO DE CONHECIMENTO FINAL
        </p>
      </button>
    </div>
  </section>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import Classes from '../_partials/Classes.vue';
import { PhCheckCircle, PhCircle, PhClock, PhListChecks, PhXCircle } from "@phosphor-icons/vue";
import { dataProgress } from '@/shared/store/progress';
import { useRoute, useRouter } from 'vue-router';

defineProps({
  modules: [Array,Object]
})

const route  = useRoute()
const router = useRouter()
const currentModule = computed(() => dataShared.getters.getActivatedModule)
const trainingStatus = computed(() => dataProgress.getters.trainingStatus);
const moduleStatus = (id) => dataProgress.getters.moduleStatusById(id)

// fluxo da prova
const canStartAssessment = computed(() => trainingStatus.value === 'passed')
const effectiveTrainingId = computed(() => route.params.mId || currentModule.value?.id)

// stilos
const label = (st) => ({
  not_started: 'Não iniciado',
  in_progress: 'Em andamento',
  passed:      'Concluído',
  failed:      'Não aprovado',
})[st] || 'Não iniciado'
const badgeClass = (st) => ({
  not_started: 'bg-gray-900 text-gray-300',
  in_progress: 'bg-blue-900 text-blue-300',
  passed:      'bg-green-900 text-green-300',
  failed:      'bg-red-900 text-red-300',
})[st] || 'bg-gray-900 text-gray-300'
const iconFor = (st) => (
  {
    not_started: PhCircle,
    in_progress: PhClock,
    passed: PhCheckCircle,
    failed: PhXCircle,
  }[st] || PhCircle);
const iconStatus = (ts) => {
  const key = `${ts}_icon`;
  return (
    {
      not_started_icon: "text-gray-500",
      in_progress_icon: "text-gray-500",
      passed_icon: "bg-green-900 text-green-300",
      failed_icon: "bg-red-900 text-red-300",
    }[key] || "text-gray-500"
  );
};
const assessmentStatus = (ts) => {
  const key = `${ts}_status`;
  return (
    {
      not_started_status: "text-gray-500",
      in_progress_status: "text-gray-500",
      passed_status: "text-white",
      failed_status: "text-gray-500",
    }[key] || "text-gray-500"
  );
};

function goToAssessment () {
  if (!canStartAssessment.value) return
  router.push({ 
    name: "avaliable-info", 
    params: { 
      id: effectiveTrainingId.value 
    } 
  })
}

</script>
